import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { IRouteAuthConfiguration, IRouteAuthConfiguration as IRouteAuthConfiguration1, PermissionType } from './auth/permission';
import { BasicComponent } from './components/common/layouts/basic.component';
import { BlankComponent } from './components/common/layouts/blank.component';
import { AccountDetailsComponent } from './views/account.management/account.details.component';
import { AddExtraAlertComponent } from './views/account.management/add.extra.alert.component';
import { BidManagementComponent } from './views/account.management/bid.management.component';
import { BookConsultationComponent } from './views/account.management/book.consultation.component';
import { CommunicationPreferencesComponent } from './views/account.management/communication.preferences.component';
import { EditExtraAlertComponent } from './views/account.management/edit.extra.alert.component';
import { ExtraAlertsListComponent } from './views/account.management/extra.alerts.list.component';
import { HelpShellComponent } from './views/account.management/help/help.shell.component';
import { HelpTeamMembersComponent } from './views/account.management/help/help.team-members.component';
import { HelpAwardsComponent } from './views/account.management/help/help.awards.component';
import { HelpBidManagementComponent } from './views/account.management/help/help.bid-management.component';
import { HelpBookDemoComponent } from './views/account.management/help/help.book-demo.component';
import { HelpContactUsComponent } from './views/account.management/help/help.contact-us.component';
import { HelpFaqComponent } from './views/account.management/help/help.faq.component';
import { HelpTenderAlertsProfileComponent } from './views/account.management/help/help.tender-alerts-profile.component';
import { HelpTrainingComponent } from './views/account.management/help/help.training.component';
import { HelpTendersComponent } from './views/account.management/help/help.tenders.component';
import { QuestionnaireComponent } from './views/account.management/questionnaire.component';
import { SubscriptionsComponent } from './views/account.management/subscriptions.component';
import { TenderAlertProfileComponent } from './views/account.management/tender.alert.profile.component';
import { ViewAccountComponent } from './views/account.management/view.account.component';
import { CompetitorNoticeComponent } from './views/competitors/competitor.notice.component';
import { CompetitorsComponent } from './views/competitors/competitors.component';
import { CaBookmarkedComponent } from './views/contract.awards/bookmarked.component';
import { CaMatchesWithIdComponent } from './views/contract.awards/matches.with.id.component';
import { CaMatchesComponent } from './views/contract.awards/my.matches.component';
import { PrintContractAwardComponent } from './views/contract.awards/print.component';
import { CaSearchComponent } from './views/contract.awards/search.component';
import { CaSearchWithIdComponent } from './views/contract.awards/search.with.id.component';
import { CaSharedBookmarkedComponent } from './views/contract.awards/shared.bookmarked.component';
import { CaBookmarksComponent } from './views/contract.awards/bookmarks.component';
import { ErrorComponent } from './views/error/error.component';
import { AcceptTeamInvitationComponent } from './views/registration/accept.team.invite.component';
import { SupplierRegistrationComponent } from './views/registration/supplier.registration.component';
import { TeamMemberThankYouComponent } from './views/registration/team.member.thank.you.component';
import { ThankYouComponent } from './views/registration/thank.you.component';
import { UnsubscribeComponent } from './views/registration/unsubscribe.component';
import { ValidateEmailComponent } from './views/registration/validate.email.component';
import { ValidationCompleteComponent } from './views/registration/validation.complete.component';
import { ResourcesComponent } from './views/resources/resources.component';
import { PaymentProcessingComponent } from './views/subscription/payment.processing.component';
import { SubscribeComponent } from './views/subscription/subscribe.component';
import { PhoneComponent } from './views/subscription/phone.component';
import { AddTeamMemberComponent } from './views/tender.team.members/add.team.member.component';
import { TeamMemberSearchComponent } from './views/tender.team.members/search.component';
import { TendersAssignedComponent } from './views/tenders/assigned.component';
import { TendersBookmarkedComponent } from './views/tenders/bookmarked.component';
import { TendersBookmarksComponent } from './views/tenders/bookmarks.component';
import { MatchesWithIdComponent } from './views/tenders/matches.with.id.component';
import { MyMatchesComponent } from './views/tenders/my.matches.component';
import { PrintTenderComponent } from './views/tenders/print.component';
import { TenderSearchComponent } from './views/tenders/search.component';
import { TendersSearchWithIdComponent } from './views/tenders/search.with.id.component';
import { SentToBidManagementComponent } from './views/tenders/sent.to.bid.management.component';
import { TendersSharedBookmarkedComponent } from './views/tenders/shared.bookmarked.component';
import { BookTrainingComponent } from './views/training/training.book.component';
import { TrainingComponent } from './views/training/training.component';
import { TrainingConfirmComponent } from './views/training/training.confirm.component';
import { TrainingDetailsComponent } from './views/training/training.details.component';
import { TrainingPaymentComponent } from './views/training/training.payment.component';
import { TrainingProcessingComponent } from './views/training/training.processing.component';
import { ForgottenPasswordComponent } from './views/userAccounts/forgottenPassword.component';
import { LogOutComponent } from './views/userAccounts/log.out.successful.component';
import { LoginComponent } from './views/userAccounts/login.component';
import { ResetPasswordComponent } from './views/userAccounts/resetPassword.component';
import { BacsComponent } from './views/subscription/bacs.component';
import { CardComponent } from './views/subscription/card.component';

export const routes: Routes = [
    //Main application tree
    {
        path: '',
        component: BasicComponent,
        children: [
            //registration
            //tenders
            {
                path: 'tenders/mymatches',
                canActivate: [AuthGuard],
                component: MyMatchesComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'tenders',
                        permission: PermissionType.Read
                    },
                    requiresAdHocPermissions: 'matches'
                } as IRouteAuthConfiguration
            },
            {
                path: 'tenders/matches/:id',
                canActivate: [AuthGuard],
                component: MatchesWithIdComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'tenders',
                        permission: PermissionType.Read
                    },
                    requiresAdHocPermissions: 'matches'
                } as IRouteAuthConfiguration
            },
            {
                path: 'tenders/search',
                canActivate: [AuthGuard],
                component: TenderSearchComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'tenders',
                        permission: PermissionType.Read
                    }
                } as IRouteAuthConfiguration
            },
            {
                path: 'tenders/searchid/:id',
                canActivate: [AuthGuard],
                component: TendersSearchWithIdComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'tenders',
                        permission: PermissionType.Read
                    }
                } as IRouteAuthConfiguration
            },
            {
                path: 'tenders/sentToBidManagement',
                redirectTo: 'bidManagement/sentToBidManagement',
                pathMatch: 'full'
            },
            {
                path: 'tenders/bookmarks',
                canActivate: [AuthGuard],
                component: TendersBookmarksComponent,
                data: {
                    requiresAdHocPermission: 'bookmarkNotice'
                } as IRouteAuthConfiguration
            },
            {
                path: 'tenders/bookmarked',
                redirectTo: 'tenders/bookmarks',
                pathMatch: 'full'
            },
            {
                path: 'tenders/sharedBookmarked',
                redirectTo: 'tenders/bookmarks',
                pathMatch: 'full'
            },
            {
                path: 'tenders/assigned',
                canActivate: [AuthGuard],
                component: TendersAssignedComponent,
                data: {
                    requiresAdHocPermission: 'bookmarkNotice'
                } as IRouteAuthConfiguration
            },
            //subscriptions
            {
                path: 'account/subscribe',
                canActivate: [AuthGuard],
                component: SubscribeComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/phone',
                canActivate: [AuthGuard],
                component: PhoneComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/card',
                canActivate: [AuthGuard],
                component: CardComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/bacs',
                canActivate: [AuthGuard],
                component: BacsComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/subscriptions',
                canActivate: [AuthGuard],
                component: SubscriptionsComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/processing/:id',
                canActivate: [AuthGuard],
                component: PaymentProcessingComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            {
                path: 'training/processing/:id',
                canActivate: [AuthGuard],
                component: TrainingProcessingComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/subscribe/:id',
                canActivate: [AuthGuard],
                component: SubscribeComponent,
                data: {
                    requiresAdHocPermissions: 'subscription'
                } as IRouteAuthConfiguration
            },
            //bid management
            {
                path: 'bidManagement/sentToBidManagement',
                canActivate: [AuthGuard],
                component: SentToBidManagementComponent,
                data: {
                    requiresAdHocPermissions: 'viewSentToBidManagement'
                } as IRouteAuthConfiguration
            },
            {
                path: 'bidManagement/about',
                canActivate: [AuthGuard],
                component: BidManagementComponent
            },
            {
                path: 'bidManagement',
                redirectTo: 'bidManagement/about',
                pathMatch: 'full'
            },
            //help
            {
                path: 'help',
                canActivate: [AuthGuard],
                component: HelpShellComponent,
                data: {
                    requiresAdHocPermissions: 'matches'
                } as IRouteAuthConfiguration,
                children: [
                    { path: '', redirectTo: 'tenders', pathMatch: 'full' },
                    { path: 'faq', component: HelpFaqComponent, data: { title: 'FAQ' } },
                    { path: 'book-a-demo', component: HelpBookDemoComponent },
                    { path: 'contact-us', component: HelpContactUsComponent },
                    { path: 'tenders', component: HelpTendersComponent },
                    { path: 'awards', component: HelpAwardsComponent },
                    { path: 'bid-management', component: HelpBidManagementComponent },
                    { path: 'training', component: HelpTrainingComponent },
                    { path: 'tender-alerts-profile', component: HelpTenderAlertsProfileComponent },
                    { path: 'team-members', component: HelpTeamMembersComponent }
                ]
            },
            //team members
            {
                path: 'teamMembers',
                canActivate: [AuthGuard],
                component: TeamMemberSearchComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'tenderTeamMember',
                        permission: PermissionType.Read
                    }
                } as IRouteAuthConfiguration
            },
            {
                path: 'teamMembers/add',
                canActivate: [AuthGuard],
                component: AddTeamMemberComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'tenderTeamMember',
                        permission: PermissionType.Add
                    }
                } as IRouteAuthConfiguration
            },
            //contract awards
            {
                path: 'contractawards/mymatches',
                canActivate: [AuthGuard],
                component: CaMatchesComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'contractAwards',
                        permission: PermissionType.Read
                    },
                    requiresAdHocPermissions: 'matches'
                } as IRouteAuthConfiguration
            },
            {
                path: 'contractawards/matches/:id',
                canActivate: [AuthGuard],
                component: CaMatchesWithIdComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'contractAwards',
                        permission: PermissionType.Read
                    },
                    requiresAdHocPermissions: 'matches'
                } as IRouteAuthConfiguration
            },
            {
                path: 'contractawards/search',
                canActivate: [AuthGuard],
                component: CaSearchComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'contractAwards',
                        permission: PermissionType.Read
                    },
                } as IRouteAuthConfiguration
            },
            {
                path: 'contractawards/searchid/:id',
                canActivate: [AuthGuard],
                component: CaSearchWithIdComponent,
                data: {
                    requiresEntityPermissions: {
                        entity: 'contractAwards',
                        permission: PermissionType.Read
                    },
                    requiresAdHocPermissions: 'matches'
                } as IRouteAuthConfiguration
            },
            {
                path: 'contractawards/bookmarks',
                canActivate: [AuthGuard],
                component: CaBookmarksComponent,
                data: {
                    requiresAdHocPermission: 'bookmarkNotice'
                } as IRouteAuthConfiguration1
            },
            {
                path: 'contractawards/bookmarked',
                redirectTo: 'contractawards/bookmarks',
                pathMatch: 'full'
            },
            {
                path: 'contractawards/sharedBookmarked',
                redirectTo: 'contractawards/bookmarks',
                pathMatch: 'full'
            },
            {
                path: 'competitors',
                canActivate: [AuthGuard],
                component: CompetitorsComponent,
                data: {
                    requiresAdHocPermission: 'bookmarkNotice'
                } as IRouteAuthConfiguration1
            },
            {
                path: 'competitorNotice/:id',
                canActivate: [AuthGuard],
                component: CompetitorNoticeComponent,
                data: {
                    requiresAdHocPermission: 'bookmarkNotice'
                } as IRouteAuthConfiguration1
            },
            {
                path: 'resources',
                canActivate: [AuthGuard],
                component: ResourcesComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            {
                path: 'training',
                redirectTo: 'training/upcoming',
                pathMatch: 'full'
            },
            {
                path: 'training/upcoming',
                canActivate: [AuthGuard],
                component: TrainingComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            {
                path: 'training/booked',
                canActivate: [AuthGuard],
                component: TrainingComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            {
                path: 'training/read/:id',
                canActivate: [AuthGuard],
                component: TrainingDetailsComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            {
                path: 'training/book/:id',
                canActivate: [AuthGuard],
                component: BookTrainingComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            {
                path: 'training/payment/:id',
                canActivate: [AuthGuard],
                component: TrainingPaymentComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            {
                path: 'training/confirm/:id',
                canActivate: [AuthGuard],
                component: TrainingConfirmComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration1
            },
            //account management
            {
                path: 'viewAccount',
                redirectTo: 'account/details',
                pathMatch: 'full'
            },
            {
                path: 'tenderAlertProfile',
                canActivate: [AuthGuard],
                component: TenderAlertProfileComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/communicationPreferences',
                canActivate: [AuthGuard],
                component: CommunicationPreferencesComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/details',
                canActivate: [AuthGuard],
                component: AccountDetailsComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/extraAlerts',
                canActivate: [AuthGuard],
                component: ExtraAlertsListComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/addExtraAlert',
                canActivate: [AuthGuard],
                component: AddExtraAlertComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/editExtraAlert/:id',
                canActivate: [AuthGuard],
                component: EditExtraAlertComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/bookConsultation',
                canActivate: [AuthGuard],
                component: BookConsultationComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            },
            {
                path: 'account/questionnaire',
                canActivate: [AuthGuard],
                component: QuestionnaireComponent,
                data: {
                    entity: 'tenders',
                    permission: PermissionType.Read
                } as IRouteAuthConfiguration
            }
        ]
    },
    //External tree = i.e. outside of menu structure
    {
        path: '',
        component: BlankComponent,
        children: [
            {
                path: 'error',
                component: ErrorComponent
            },
            {
                path: 'account/login',
                component: LoginComponent
            },
            {
                path: 'account/forgottenPassword',
                component: ForgottenPasswordComponent
            },
            {
                path: 'account/resetPassword/:token',
                component: ResetPasswordComponent
            },
            {
                path: 'account/logout',
                component: LogOutComponent
            },
            //registration
            {
                path: 'registration',
                component: SupplierRegistrationComponent
            },
            {
                path: 'registration/ref/:refId',
                component: SupplierRegistrationComponent
            },
            {
                path: 'registration/gclid/:gcl',
                component: SupplierRegistrationComponent
            },
            {
                path: 'registration/gclid/:gcl/cat/:catId/loc/:locId',
                component: SupplierRegistrationComponent
            },
            {
                path: 'registration/cat/:catId',
                component: SupplierRegistrationComponent
            },
            {
                path: 'registration/cat/:catId/loc/:locId',
                component: SupplierRegistrationComponent
            },
            {
                path: 'registration/acceptTeamInvite/:token',
                component: AcceptTeamInvitationComponent
            },
            {
                path: 'registration/thanks',
                component: TeamMemberThankYouComponent
            },
            {
                path: 'registration/thankyou',
                component: ThankYouComponent
            },
            {
                path: 'unsubscribe/:id',
                component: UnsubscribeComponent
            },
            {
                path: 'registration/validateEmail/:id',
                component: ValidateEmailComponent
            },
            {
                path: 'registration/validationComplete',
                component: ValidationCompleteComponent
            },
            //printing screens
            {
                path: 'tenders/print/:id',
                canActivate: [AuthGuard],
                component: PrintTenderComponent,
                data: {
                    requiresAdHocPermissions: 'tenderActions'
                } as IRouteAuthConfiguration
            },
            {
                path: 'contractAwards/print/:id',
                canActivate: [AuthGuard],
                component: PrintContractAwardComponent,
                data: {
                    requiresAdHocPermissions: 'contractAwardActions'
                } as IRouteAuthConfiguration
            }
        ]
    },
    // Handle all other routes by redirecting to my matches
    { path: '**', redirectTo: 'tenders/mymatches' , pathMatch: 'full' }
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/app.routes.ts